

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog"  >
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="column" id="main">
          <h1>Connexion</h1>
          <h3>Use your Github account to access to JanguKit Repository</h3>

          <button class="google-btn" (click)="githubLogin()">
            <img src="./assets/github.svg" height="40px" alt="Google Logo" class="google-logo">
            Login with Github
          </button>

        </div>


      </div>
    </div>
  </div>
</div>
